var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPracticeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.152 0.700195H0.900391V109.269H109.152V0.700195Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1879 35.2245L26.5326 16.0439H24.5205V69.2704H38.5238V41.8824L51.1879 52.0173V35.2245Z",
    fill: "#D81D5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3947 16.0439L58.915 35.2032V51.9845L71.4804 41.8057V69.2704H85.4835V16.0439H83.3947Z",
    fill: "#D81D5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2741 81.1924L50.7969 89.5477H54.3357L55.1524 87.2791H56.4646L54.2741 81.1924Z",
    fill: "#587E85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9181 89.547H64.4975L59.3436 77.207H56.4746L60.9181 89.547Z",
    fill: "#587E85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6307 81.5829L17.8777 77.1074H17.4082V89.527H20.6756V83.1364L23.6307 85.5011V81.5829Z",
    fill: "#587E85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1455 77.1074L25.4336 81.578V85.4935L28.3655 83.1184V89.5269H31.6329V77.1074H31.1455Z",
    fill: "#587E85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7256 89.0839V86.1231C85.6211 86.5764 86.6934 86.9112 87.7127 86.9984C88.0642 87.0298 88.399 87.0298 88.7158 87.0125C89.7515 86.9462 90.3322 86.6776 90.3322 86.172C90.3322 85.5338 89.5404 85.213 87.9949 84.655C85.8669 83.8842 84.4961 83.0403 84.4961 80.8188C84.4961 78.5973 86.4131 77.1465 89.2946 77.1465C90.5598 77.1465 91.8268 77.3837 92.6696 77.722V80.5677C91.9141 80.1108 90.7182 79.8074 89.5586 79.8074C88.399 79.8074 87.66 80.1944 87.66 80.8013C87.66 81.3732 88.3991 81.7603 89.8754 82.3323C92.0016 83.1414 93.4614 83.9993 93.4614 86.1546C93.4614 88.3935 91.703 89.7431 88.5574 89.7431C87.1156 89.7429 85.6739 89.471 84.7256 89.0839Z",
    fill: "#587E85"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1714 77.3125H33.8867V89.5437H37.1714V77.3125Z",
    fill: "#587E85"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4292 77.3125H79.1445V89.5437H82.4292V77.3125Z",
    fill: "#587E85"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.777 87.6227L47.7009 84.5532C47.9187 84.5171 48.1364 84.4806 48.3542 84.4082C49.806 83.9726 50.9675 82.8655 50.9675 81.0145C50.9675 78.6735 49.0984 77.3125 46.3579 77.3125H39.4258V89.5437H42.7105V85.2427V84.9525V82.5753V81.6135V79.7625H45.9225C47.0476 79.7625 47.6102 80.3612 47.6102 81.1054C47.6102 82.0308 47.0113 82.5753 45.868 82.5753H44.463V85.0005L47.1745 89.5438H48.9864L49.777 87.6227Z",
    fill: "#587E85"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4726 79.9714L68.6568 77.3125H64.5918L69.0015 83.3737L65.6618 87.9894L66.3125 89.5435H68.5297L70.4159 86.9231L70.4726 79.9714Z",
    fill: "#587E85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5383 83.3736L77.9662 77.3125H73.9558L72.1104 79.9676L72.1106 86.935L73.9192 89.5436H77.9843L73.5383 83.3736Z",
    fill: "#587E85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9183 89.5488L56.475 77.209L55.9099 77.2157L55.2344 78.8784L59.2536 89.5488H60.9183Z",
    fill: "#B4C5C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPracticeLogo);
export default __webpack_public_path__ + "static/media/product-practice-logo.e428ff59eaedb76d3f87f218a2a42e99.svg";
export { ForwardRef as ReactComponent };